import { CashAppGuideline } from '../models';
import { ModelResource } from './resource';

export class CashAppGuidelines extends ModelResource<CashAppGuideline> {
  model = CashAppGuideline;

  resourcePath = 'v1/cash-app/guidelines';
}
